var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Button, Dimmer, Form, Grid, Loader, Message, Modal, Segment } from "semantic-ui-react";
import { InvalidCartItem, is4xx, ValidCartItem } from "./CartPage";
import { ORIGIN } from "./Config";
import ErrorDisplay from "./ErrorDisplay";
import EditCommentModal from "./kit/EditCommentModal";
import { buildEditFormStateHandlerForComponent } from "./kit/FormState";
import { EditKitForm as Ihc2EditKitForm, serializeIhc2Kit } from "./kit/ihc2/EditKitForm";
import ManualProConsumerKitForm from "./kit/bundle-of-kits/ManualProConsumerKitForm";
import KitIndexHeader from "./kit/KitIndexHeader";
import ProKitForm from "./kit/rna-cish/ProKitForm";
import EditKitForm, { CART_PRICE_PATH } from "./kit/rna-fish/EditKitForm";
import KitDisplay from "./kit/rna-fish/KitDisplay";
import { BundleOfKits, PricedBundleOfKits, RnaCishKit, RnaFishKit, RnaFishPricedKit } from "./kit/rna-fish/KitModel";
import { ErrorElements, kitPriceToGoogleAnalyticsItems } from "./kit/rna-fish/NewRnaFishKitPage";
import { DetectOnly, ProbeDetect, ProbeOnly } from "./KitDeserializer";
import { deleteWithAuthn, postJsonWithAuthn } from "./RequestHelpers";
import ChromogenKitForm from "./kit/rna-cish/ChromogenKitForm";
var CartItemView = /** @class */ (function (_super) {
    __extends(CartItemView, _super);
    function CartItemView(props) {
        var _this = _super.call(this, props) || this;
        _this.setRnaFishFormState = buildEditFormStateHandlerForComponent('rnaFishFormState', _this);
        _this.setIhc2FormState = buildEditFormStateHandlerForComponent('ihc2FormState', _this);
        _this.setRnaCishFormState = buildEditFormStateHandlerForComponent('rnaCishFormState', _this);
        _this.setChromogenKitFormState = buildEditFormStateHandlerForComponent('chromogenKitFormState', _this);
        _this.setManualProFormState = buildEditFormStateHandlerForComponent('manualProKitFormState', _this);
        _this.editComment = function (item) {
            var button = React.createElement(Button, { onClick: _this.onCommentModalOpenClick, icon: 'edit', label: item.kit.comment.length === 0 ? 'Add Comment' : 'Edit Comment', labelPosition: "left" });
            var onSaveClick = function () { return _this.onSave(item); };
            var formNode = React.createElement(EditCommentModal, { kitPriceUrlPath: CART_PRICE_PATH, fishFormState: _this.state.rnaFishFormState, ishFormState: _this.state.rnaCishFormState, chromogenFormState: _this.state.chromogenKitFormState, ihc2FormState: _this.state.ihc2FormState, manualProFormState: _this.state.manualProKitFormState, setFishFormState: _this.setRnaFishFormState, setIshFormState: _this.setRnaCishFormState, setChromogenFormState: _this.setChromogenKitFormState, setIhc2FormState: _this.setIhc2FormState, setManualProFormState: _this.setManualProFormState, initialComment: item.kit.comment });
            var handleKeyDown = function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    onSaveClick();
                }
            };
            return React.createElement(Modal, { onKeyDown: handleKeyDown, closeIcon: true, open: _this.state.editCommentOpen, 
                // size={'large'}
                onClose: _this.onCancel, trigger: button },
                React.createElement(Modal.Header, null, item.kit.comment.length === 0 ? 'Add Comment' : 'Edit Comment'),
                React.createElement(Modal.Content, null,
                    React.createElement(Dimmer.Dimmable, { as: Form, error: _this.state.errors.length > 0 || _this.state.rnaFishFormState.errors.length > 0 },
                        React.createElement(Dimmer, { active: _this.state.editItemLoading, inverted: true },
                            React.createElement(Loader, null)),
                        formNode,
                        React.createElement("br", null),
                        React.createElement(ErrorDisplay
                        // error display for when updating fails
                        , { 
                            // error display for when updating fails
                            errors: _this.state.errors, errorPath: "/contents/" + item.id }),
                        React.createElement("div", { style: { 'textAlign': 'right' } },
                            React.createElement(Button, { icon: 'cancel', label: 'Cancel', labelPosition: 'left', onClick: _this.onCancel }),
                            React.createElement(Button, { icon: 'save', label: 'Save', className: ORIGIN === "hcr" ? "cish-button" : "", labelPosition: 'left', onClick: onSaveClick, positive: true })))));
        };
        _this.editModal = function (item) {
            var button = React.createElement(Button, { onClick: _this.onModalOpenClick, icon: 'edit', label: "Edit kit", labelPosition: 'left' });
            var onSaveClick = function () { return _this.onSave(item); };
            var kitPriceUrlPath = CART_PRICE_PATH;
            // TODO this is ugly
            var formNode;
            if (item.pricedKit instanceof RnaFishPricedKit) {
                formNode = React.createElement(EditKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.rnaFishFormState, loadPriceOnMount: true, restrictCustomTargetProbeSetSizeToCatalog: true, enableCustomPrice: false, enableAmplifierCustomScale: false, enableProbeSetCustomScale: false, enableBufferCustomScale: false, setFormState: _this.setRnaFishFormState, legacy: item.pricedKit.kit.legacy, showErrors: true });
            }
            else if (_this.rnaCishProKitCheck(item.pricedKit.kit)) {
                formNode = React.createElement("div", { className: 'consumer-edit-enzymatic-ish-form' },
                    React.createElement(ProKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.rnaCishFormState, setFormState: _this.setRnaCishFormState, kitConfigurations: [ProbeDetect, ProbeOnly, DetectOnly], loadPriceOnMount: true }));
            }
            else if (_this.rnaCishChromogenOnlyKitCheck(item.pricedKit.kit)) {
                formNode = React.createElement("div", { className: 'consumer-edit-enzymatic-ish-form' },
                    React.createElement(ChromogenKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.chromogenKitFormState, setFormState: _this.setChromogenKitFormState, loadPriceOnMount: true }));
            }
            else if (item.pricedKit instanceof PricedBundleOfKits) {
                formNode = React.createElement(ManualProConsumerKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.manualProKitFormState, loadPriceOnMount: true, restrictCustomTargetProbeSetSizeToCatalog: true, enableCustomPrice: false, enableAmplifierCustomScale: false, enableProbeSetCustomScale: false, enableBufferCustomScale: false, setFormState: _this.setManualProFormState, showErrors: true });
            }
            else {
                formNode = React.createElement(Ihc2EditKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.ihc2Catalog, formState: _this.state.ihc2FormState, loadPriceOnMount: true, setFormState: _this.setIhc2FormState, legacy: item.pricedKit.kit.legacy, showErrors: true });
            }
            return React.createElement(Modal, { closeIcon: true, open: _this.state.editModalOpen, size: 'large', onClose: _this.onCancel, trigger: button },
                React.createElement(Modal.Header, null, "Edit kit"),
                React.createElement(Modal.Content, null,
                    React.createElement(Dimmer.Dimmable, { as: Form, error: _this.state.errors.length > 0 || _this.state.rnaFishFormState.errors.length > 0 },
                        React.createElement(Dimmer, { active: _this.state.editItemLoading, inverted: true },
                            React.createElement(Loader, null)),
                        formNode,
                        React.createElement(ErrorDisplay
                        // error display for when updating fails
                        , { 
                            // error display for when updating fails
                            errors: _this.state.errors, errorPath: "/contents/" + item.id }),
                        React.createElement("div", { style: { 'textAlign': 'right' } },
                            React.createElement(Button, { icon: 'cancel', label: 'Cancel', labelPosition: 'left', onClick: _this.onCancel }),
                            React.createElement(Button, { icon: 'save', label: 'Save', labelPosition: 'left', onClick: onSaveClick, className: ORIGIN === "hcr" ? "cish-button" : "", positive: true })))));
        };
        _this.onModalOpenClick = function () {
            _this.setState({
                editModalOpen: true,
                rnaFishFormState: _this.props.initialRnaFishEditFormState,
                ihc2FormState: _this.props.initialIhc2EditFormState,
                rnaCishFormState: _this.props.initialRnaCishFormState,
                manualProKitFormState: _this.props.initialManualProFormState
            });
        };
        _this.onCommentModalOpenClick = function () {
            _this.setState({
                editCommentOpen: true
            });
        };
        _this.onDeleteModalOpenClick = function () {
            _this.setState({
                deleteModalOpen: true
            });
        };
        _this.onCancel = function () {
            _this.setState({
                editModalOpen: false,
                editCommentOpen: false,
                deleteModalOpen: false,
                errors: [],
                rnaFishFormState: _this.props.initialRnaFishEditFormState,
                ihc2FormState: _this.props.initialIhc2EditFormState,
                rnaCishFormState: _this.props.initialRnaCishFormState,
                manualProKitFormState: _this.props.initialManualProFormState
            });
        };
        _this.onSave = function (item) {
            var path = "/cart/item/id/" + encodeURIComponent(item.id);
            _this.setState({
                editItemLoading: true
            }, function () {
                var body;
                if (item.pricedKit.kit instanceof RnaFishKit) {
                    body = EditKitForm.serializeRnaFishKit(_this.state.rnaFishFormState);
                }
                else if (_this.rnaCishProKitCheck(item.pricedKit.kit)) {
                    body = ProKitForm.serializeProKit(_this.state.rnaCishFormState);
                }
                else if (_this.rnaCishChromogenOnlyKitCheck(item.pricedKit.kit)) {
                    body = ChromogenKitForm.serializeChromogenKit(_this.state.chromogenKitFormState);
                }
                else if (item.pricedKit.kit instanceof BundleOfKits) {
                    body = ManualProConsumerKitForm.serializeManualProConsumerKit(_this.state.manualProKitFormState);
                }
                else {
                    body = serializeIhc2Kit(_this.state.ihc2FormState);
                }
                postJsonWithAuthn(path, JSON.stringify(body))
                    .then(function (resp) {
                    if (is4xx(resp.status)) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors);
                        });
                    }
                    return resp.json();
                })
                    .then(function (json) {
                    if (json instanceof ErrorElements) {
                        _this.setState({
                            errors: json.errors,
                            editItemLoading: false
                        }, function () {
                            // TODO so ugly...
                            // pass the errors along to the form
                            _this.setRnaFishFormState(function () { return ({
                                errors: json.errors
                            }); });
                            _this.setIhc2FormState(function () { return ({
                                errors: json.errors
                            }); });
                            _this.setRnaCishFormState(function () { return ({
                                errors: json.errors
                            }); });
                            _this.setChromogenKitFormState(function () { return ({
                                errors: json.errors
                            }); });
                            _this.setManualProFormState(function () { return ({
                                errors: json.errors
                            }); });
                        });
                    }
                    else {
                        _this.props.onCartChange(json);
                        _this.setState({
                            errors: [],
                            editItemLoading: false,
                            editModalOpen: false,
                            editCommentOpen: false,
                            deleteModalOpen: false
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't update kit: " + rej);
                });
            });
        };
        _this.deleteItem = function (item) {
            _this.props.setParentLoadingState(true);
            var path = "/cart/item/id/" + encodeURIComponent(item.id);
            _this.setState({
                editItemLoading: true
            }, function () {
                deleteWithAuthn(path)
                    .then(function (resp) {
                    if (is4xx(resp.status)) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors);
                        });
                    }
                    return resp.json();
                })
                    .then(function (json) {
                    if (json instanceof ErrorElements) {
                        _this.setState({
                            errors: json.errors
                        }, function () {
                            _this.props.setParentLoadingState(false);
                        });
                    }
                    else {
                        _this.props.onCartChange(json);
                        _this.setState({
                            errors: [],
                            editItemLoading: false,
                            editModalOpen: false,
                            editCommentOpen: false,
                            deleteModalOpen: false
                        });
                        _this.props.setParentLoadingState(false);
                        if (item instanceof ValidCartItem) {
                            _this.setState({
                                deleteModalOpen: false
                            }, function () {
                                gtag('event', 'remove_from_cart', {
                                    value: item.pricedKit.price.subtotalCents / 100.0,
                                    currency: 'USD',
                                    items: [kitPriceToGoogleAnalyticsItems(item.pricedKit.price)]
                                });
                            });
                        }
                        else {
                            // TODO("Handle GTAG Case")
                        }
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't update count: " + rej);
                });
            });
        };
        _this.rnaCishProKitCheck = function (kit) {
            return kit instanceof RnaCishKit && (kit.probeSetComponent !== undefined || kit.amplifierComponent !== undefined ||
                kit.bufferComponent !== undefined);
        };
        _this.rnaCishChromogenOnlyKitCheck = function (kit) {
            return kit instanceof RnaCishKit && kit.chromogenComponent !== undefined &&
                kit.probeSetComponent === undefined && kit.amplifierComponent === undefined &&
                kit.bufferComponent === undefined;
        };
        _this.state = {
            editItemLoading: false,
            errors: [],
            editModalOpen: false,
            editCommentOpen: false,
            deleteModalOpen: false,
            rnaFishFormState: props.initialRnaFishEditFormState,
            ihc2FormState: props.initialIhc2EditFormState,
            rnaCishFormState: props.initialRnaCishFormState,
            chromogenKitFormState: _this.props.initialChromogenKitFormState,
            manualProKitFormState: _this.props.initialManualProFormState
        };
        return _this;
    }
    CartItemView.prototype.render = function () {
        var _this = this;
        var item = this.props.item;
        var onDeleteClick = function () { return _this.deleteItem(item); };
        return React.createElement(Segment, { key: this.props.offset },
            item instanceof InvalidCartItem &&
                React.createElement(Message, { error: true },
                    "This item is no longer available. Please remove the kit from your cart and contact ",
                    React.createElement("a", { href: "mailto:support@molecularinstruments.com" }, "support@molecularinstruments.com"),
                    " for more information."),
            React.createElement(KitIndexHeader, { itemIndex: this.props.offset, kit: item.kit }),
            item instanceof ValidCartItem && React.createElement(KitDisplay, { pricedKit: item.pricedKit, displayBlastLink: false, admin: false }),
            item instanceof InvalidCartItem && React.createElement(KitDisplay, { kit: item.kit, displayBlastLink: false, admin: false }),
            React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement("div", { className: 'kit-buttons' },
                            item instanceof ValidCartItem && ORIGIN !== "mi" && this.editComment(item),
                            item instanceof ValidCartItem && this.editModal(item),
                            React.createElement(Modal, { closeIcon: true, open: this.state.deleteModalOpen, size: 'large', onClose: this.onCancel, trigger: React.createElement(Button, { onClick: this.onDeleteModalOpenClick, icon: 'trash', label: "Remove kit", labelPosition: "left", negative: true }) },
                                React.createElement(Modal.Header, null, "Confirm Action"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(Dimmer, { active: this.state.editItemLoading, inverted: true },
                                        React.createElement(Loader, null)),
                                    React.createElement("p", null, "Are you sure you want to delete?"),
                                    React.createElement(Button, { icon: 'trash', label: "Remove kit", labelPosition: 'left', negative: true, onClick: onDeleteClick })))),
                        React.createElement(ErrorDisplay
                        // error display for when deleting/updating fails
                        , { 
                            // error display for when deleting/updating fails
                            errors: this.state.errors, errorPath: "/contents/" + item.id })))));
    };
    return CartItemView;
}(React.PureComponent));
export default CartItemView;
//# sourceMappingURL=CartItemView.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/CartItemView.js
// module id = 919
// module chunks = 0